import { PDF } from './documents';

export class ArticleDetailData {
  article: Article | null = null;
  magazine: Magazine | null = null;
  related: Related | null = null;
  interest: Related[] = [];
}

export interface Article {
  id: number;
  title: string;
  meta_title: string;
  slug: string;
  subtitle: string | null;
  meta_description: string;
  cover: string;
  image: string;
  caption: string;
  content: string;
  author_id: number | null;
  category_id: number;
  subject_id: number;
  mode_id: number;
  venue_id: number | null;
  related_id: number;
  magazine_id: number;
  url: string | null;
  url_name: string | null;
  collabs_image: string | null;
  collabs_url: string | null;
  starts_at: string | null;
  ends_at: string | null;
  spotify: string | null;
  tags: string;
  is_calendar: number;
  is_draft: number;
  media_type: string;
  banner_color: string;
  pdf: PDF[];
  weight: number;
  editorial: number;
  notes: string | null;
  views: number;
  created_at: string;
  updated_at: string;
  podcast_js_src: string | null;
  author: Author | null;
  category: Category;
  subject: Subject;
  mode: Category;
  venue: string | null;
  magazine: Magazine;
}

export interface Category {
  id: number;
  name: string;
  description?: string | null;
  slug: string;
  created_at: string;
  updated_at: string;
}

export interface Magazine {
  id: number;
  title: string;
  slug: string;
  cover: string;
  topic: string;
  number: number;
  url: string;
  url_text: string;
  mag_articles: string | null;
  created_at: string;
  updated_at: string;
  first_id: number | null;
  second_id: number | null;
  third_id: number | null;
  pdf: PDF[];
  featured: string;
  season: string;
  current: number;
}

export interface Subject {
  id: number;
  name: string;
  slug: string;
  cover: string;
  active: number;
  created_at: string;
  updated_at: string;
}

export interface Related {
  id: number;
  title: string;
  slug: string;
  subtitle: string | null;
  image: string;
  cover: string;
  caption: null | string;
  meta_description: string;
  author_id: number;
  subject_id: number;
  author: Author;
  category: string | null;
  subject: Subject;
  mode: string | null;
  venue: string | null;
}

export interface Author {
  id: number;
  name: string;
  surname: string;
  photo: string;
  bio: string;
  link: null | string;
  featured: number;
  created_at: string;
  updated_at: string;
}
